import { render, staticRenderFns } from "./sDataLaborView.vue?vue&type=template&id=5fc0305a"
import script from "./sDataLaborView.vue?vue&type=script&lang=js"
export * from "./sDataLaborView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports